import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledActionCTAsContainer = styled.div`
  align-content: center;
  align-items: end;
  display: flex;
  flex-direction: column-reverse;
  gap: 8px;
  justify-content: flex-end;
  padding: ${({ theme }) => theme.size.static300} 0px 0px 0px;
  
  @media (min-width: ${Breakpoints.b560}px) {
    padding: 20px 16px 0px;
    flex-direction: row;
  }

  button {
    @media (min-width: ${Breakpoints.b560}px) {
      width: 141px;
    }
  }
`